export default __webpack_public_path__ + "static/media/pic59.da19911e.JPG";